function stepBarDirective() {
	return {
		scope : {
			steps : '=',
			currentStep : '@',
			stateClass : '@',
			stateConstants: '@'
		},
		restrict : 'E',
		replace : true,
		templateUrl : function(elem, attr) {
			return 'views/directives/stepBarDirective.html';
		},
		link : function(scope, element, attrs) {
			scope.divCol = 'col-md-'+getDiv();
			getClasses();
			function getDiv(){
				if(scope.steps.length > 12)
					return "1";
				 return Math.ceil(12/scope.steps.length);
			}
			
			function getClasses(){
				scope.steps.forEach(function(s){
					s.className = getConstantByName(eval(scope.stateConstants), s.name).className;
				});
			}
			
		}
	};
};

module.directive('stepBar', [ stepBarDirective ]);